module.exports = __webpack_public_path__ + "img/club-intro.2141b529.jpg";